import  { createContext } from 'react';
import { LoginState, LoginAction } from '../types';

interface ContextProps {
  state: LoginState;
  dispatch: (action: LoginAction) => void;
}

export const AuthContext = createContext({} as ContextProps);
